import React from 'react';
import * as styles from './aiEngineerFellowship.module.scss';

const Testimonials = ({ quotes }) => {
  return (
    <section id="community" className={styles.mint}>
      <div className={styles.wrap}>
        <div className={styles.shead}>
          <h2>What Crio Learners Say</h2>
          <p>
            Real experiences from professionals who transformed their careers
            with Crio.
          </p>
        </div>
        <div className={styles.quotes}>
          {quotes.map((q) => (
            <div className={styles.quote} key={q.name}>
              <p>&quot;{q.quote}&quot;</p>
              <div className={styles.who}>
                <div>
                  <b>{q.name}</b>
                  <span>
                    {q.role}{' '}
                    <span className={styles.cofav}>
                      <img
                        src={`https://www.google.com/s2/favicons?domain=${q.domain}&sz=128`}
                        alt=""
                        loading="lazy"
                        onError={(e) => e.currentTarget.remove()}
                      />
                      {q.company}
                    </span>
                  </span>
                </div>
              </div>
            </div>
          ))}
        </div>
        <div className={styles.ratings}>
          <span>
            <span className={styles.star}>★</span> 4.5/5 average rating
          </span>
          <span>3000+ developers trained</span>
          <span>1500+ hiring partners</span>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
